export default "__VITE_ASSET__DPRw3FrX__"